import { createFileRoute } from "@tanstack/react-router";
import { CelebrityResultPage } from "@/components/site/CelebrityResultPage";
import { mikeBibby } from "@/lib/celebrity-results/mike-bibby";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Mike Bibby Hair Transplant Results | RESTORE Hair";
const DESC = "Learn why Mike Bibby came to RESTORE. See behind the scenes photos and hear his story on how RESTORE has helped him.";
const POSTER = "/img/r/wp-2024-09-mike-bibby-poster.webp";

export const Route = createFileRoute("/results/mike-bibby")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://restorehair.com/results/mike-bibby/" },
      { property: "og:image", content: absoluteUrl(mikeBibby.heroBackground ?? "") },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(mikeBibby.heroBackground ?? "") },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/results/mike-bibby/" },
    ],
  }),
  component: () => <CelebrityResultPage data={mikeBibby} />,
});
